import COOKIE_CONSENT from '../../../conf/CookiesConsentConfig.json'
import { addCookieConsent, hasCookieConsent, removeCookieConsent } from '../utils/CookieConsentUtils'
import { PlaceInAkixiNameSpace } from '../utils/Utils'
import { $window } from '../utils/WindowFunctions'

const GA_ID: string = 'G-3Q5HYTMQQ7'

enum GAArguments {
    CONSENT = 'consent',
    AD_STORAGE = 'ad_storage',
    ANALYTICS_STORAGE = 'analytics_storage',
    DEFAULT = 'default',
    UPDATE = 'update',
    JS = 'js',
    CONFIG = 'config'
}

enum GAConsentStates {
    DENIED = 'denied',
    GRANTED = 'granted'
}

const getCookieConsentForGAAsState = (): string => {
    const consentGiven: boolean = hasCookieConsent(COOKIE_CONSENT.statistics[0])

    return consentGiven ? GAConsentStates.GRANTED : GAConsentStates.DENIED
}

const gaDataLayerSetup = (): void => {
    $window.dataLayer = $window.dataLayer ?? []

    // eslint-disable-next-line
    $window.gtag =
        $window.gtag ??
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((...args: any[]): void => {
            $window.dataLayer.push(args)
        })

    $window.gtag(GAArguments.CONSENT, GAArguments.DEFAULT, {
        [GAArguments.AD_STORAGE]: GAConsentStates.DENIED,
        [GAArguments.ANALYTICS_STORAGE]: GAConsentStates.DENIED
    })
}

const gaConfig = (): void => {
    $window.gtag(GAArguments.JS, new Date())
    $window.gtag(GAArguments.CONFIG, GA_ID)
}

export const updateGoogleAnalyticsConsent = (): void => {
    const storageAccess: string = getCookieConsentForGAAsState()

    $window.gtag(GAArguments.CONSENT, GAArguments.UPDATE, {
        [GAArguments.AD_STORAGE]: storageAccess,
        [GAArguments.ANALYTICS_STORAGE]: storageAccess
    })
}

export const grantGACookieConsent = (): void => {
    addCookieConsent(...COOKIE_CONSENT.statistics)
    updateGoogleAnalyticsConsent()
}

export const revokeGACookieConsent = (): void => {
    removeCookieConsent(...COOKIE_CONSENT.statistics)
    updateGoogleAnalyticsConsent()
}

const addGoogleAnalytics = (): void => {
    if (!$window.GAInitialised) {
        $window.GAInitialised = true
        gaDataLayerSetup()
        gaConfig()
        updateGoogleAnalyticsConsent()
    }
}

setTimeout((): void => {
    addGoogleAnalytics()
})

PlaceInAkixiNameSpace('gaDataLayerSetup', gaDataLayerSetup)
PlaceInAkixiNameSpace('grantGACookieConsent', grantGACookieConsent)
PlaceInAkixiNameSpace('revokeGACookieConsent', revokeGACookieConsent)
